export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 'faq-01',
    question: '什么是火影西瓜？',
    answer: '火影西瓜是将火影忍者IP与西瓜创意融合的趣味玩法，包括火影角色造型DIY、主题切法教程、西瓜雕刻艺术、火影周边美食等多个维度。它既是一种创意美食文化，也是火影粉丝表达热爱的独特方式。',
  },
  {
    id: 'faq-02',
    question: '火影西瓜需要什么工具？',
    answer: '基础工具包括：一把锋利的水果刀、水果雕刻刀套装、挖球器、记号笔和勺子。进阶玩家还可以准备食用色素、可食用闪粉等装饰材料。新手建议从基础工具开始，逐步添置。',
  },
  {
    id: 'faq-03',
    question: '新手应该从哪个火影西瓜项目开始？',
    answer: '强烈推荐从木叶标志切法开始，这是最基础也是最经典的项目。掌握基本的弧线和直线切法后，可以进阶到写轮眼切法，最后挑战完整的角色造型如鸣人或卡卡西。',
  },
  {
    id: 'faq-04',
    question: '火影西瓜造型能保存多久？',
    answer: '由于西瓜含水量高，雕刻后的造型建议在4-6小时内食用或展示。如需延长展示时间，可以在完成后放入冰箱冷藏（不超过12小时），但要注意避免水分流失影响外观。建议在派对开始前1-2小时完成雕刻。',
  },
  {
    id: 'faq-05',
    question: '雕刻失败的西瓜还能吃吗？',
    answer: '当然可以！火影西瓜的核心理念就是"好看又好吃"。即使雕刻不完美，西瓜本身依然美味。我们鼓励"失败也是忍道"的精神，每一次尝试都是通往忍术大师的修炼之路。',
  },
  {
    id: 'faq-06',
    question: '有没有适合小朋友的火影西瓜玩法？',
    answer: '有的！我们推荐儿童安全版火影西瓜玩法：使用塑料安全刀具、用饼干模具压出火影角色形状的西瓜块、或者在家长的帮助下进行简单的木叶标志涂鸦。安全第一，创意无限！',
  },
  {
    id: 'faq-07',
    question: '火影西瓜适合什么场合？',
    answer: '火影西瓜适合各种场合！火影主题派对是首选，此外夏日烧烤聚会、动漫展、生日派对、甚至公司团建活动都可以加入火影西瓜元素。它不仅是一道美食，更是一个互动话题和拍照打卡点。',
  },
  {
    id: 'faq-08',
    question: '如何拍出好看的火影西瓜照片？',
    answer: '拍照技巧：1）使用自然光或柔和的侧光，避免正上方直射光；2）背景简洁，推荐原木色或深色桌面；3）俯拍45度角最能展现雕刻细节；4）可以搭配火影手办、护额等周边道具增加氛围感；5）切开后的内部结构也是很好的拍摄素材。',
  },
];